var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.66671C5.42267 2.66671 3.33333 4.75605 3.33333 7.33337C3.33333 8.8041 4.22405 10.1787 5.46994 11.2585L7.76423 13.2468C7.89954 13.3641 8.10047 13.3641 8.23578 13.2468L10.5301 11.2585C11.776 10.1787 12.6667 8.8041 12.6667 7.33337C12.6667 4.75605 10.5773 2.66671 8 2.66671ZM2 7.33337C2 4.01967 4.68629 1.33337 8 1.33337C11.3137 1.33337 14 4.01967 14 7.33337C14 9.35097 12.7935 11.0612 11.4033 12.266L9.10902 14.2544C8.47256 14.806 7.52745 14.806 6.89099 14.2544L4.5967 12.266C3.20651 11.0612 2 9.35097 2 7.33337Z",
    fill: "#F4F6F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M9.33268 7.33333C9.33268 8.06971 8.73573 8.66667 7.99935 8.66667C7.26297 8.66667 6.66602 8.06971 6.66602 7.33333C6.66602 6.59695 7.26297 6 7.99935 6C8.73573 6 9.33268 6.59695 9.33268 7.33333Z",
    fill: "#F4F6F7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGray);
export default __webpack_public_path__ + "static/media/location_gray.2654d435e38cd284204e7c736709a1c3.svg";
export { ForwardRef as ReactComponent };